import React from 'react';

export const CoverageTableHeader = () => {
    return <thead>
    <tr>
        <th>Covers</th>
        <th>Cost per month</th>
        <th/>
    </tr>
    </thead>;
};

export default CoverageTableHeader;
